import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { ThNavHeader } from './ThNavHeader';
import { ThNavFooter } from './ThNavFooter';

import { getClientId } from './utils/analyticsclientIdUtils';

class ThAuthJoinDetailThxClass extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);

        {
            // Google analytic
            const documentPath = "TH Join - thank"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
    }

    render() {
    return (
        <>
            <ThNavHeader />

            <main id="main">
                <section className="top-sr-bg bg-gray1">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col col-md-6">
                                <h1 className="text-headpage text-white mb-0 pt-3 pb-3 "><span className="text-black">สตาร์บัคส์ รีวอร์ด</span></h1>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-sign-in overflow-hidden pb-5">
                    <div className="container-fluid p-3 p-md-0">
                        <div className="row">
                            <div className="col-md-12 mb-4 pt-3 text-center">
                                <h2 className="h1 mt-5 fw-bold text-green-1">ขอบคุณ!</h2>
                                <h4 className="text-dark-212121 fw-semibold">บัญชีสตาร์บัคส์ รีวอร์ด ของคุณถูกสร้างเรียบร้อยแล้ว</h4>
                                <div className="mt-4">
                                    <div className="gap-2 d-md-flex justify-content-center">
                                        <Link to="/thhome" className="btn btn-green-1 rounded-pill text-decoration-none mb-3 mr-3">หน้าหลัก</Link>
                                        <Link to="/authsigninth" className="btn btn-outline-green-1 rounded-pill text-decoration-none mb-3">จัดการบัญชีของคุณ</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-3 mb-3">
                                <div className="text-center">
                                    <img src="media/rewards/SBX_GLOBAL_MTR_16.png" alt="Please check your email and click on verification link." className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>


            <ThNavFooter />
      </>
    );
  }
}

export const ThAuthJoinDetailThx = withRouter(ThAuthJoinDetailThxClass);